'use strict';

var toastr = require('toastr');
var GridFetchHostShareButtonController = function GridFetchHostShareButtonController($scope, hepService) {
  var gridPanel = $scope.gridPanelScope;
  $scope.onRowSelection = function (selectedRows) {
    $scope.isDuplicateButtonShown = !$scope.isDefaultLevel && $scope.isGridEditable && selectedRows.length > 0;
    $scope.selectedRows = selectedRows;
  };
  $scope.fetchHostShare = function () {
    hepService.fetchNPS().then(function () {
      toastr.success('Successfully Fetched');
      gridPanel.refreshGridButtonHandler();
    }, function () {
      toastr.error('Error in Fetched');
    });
  };
};
GridFetchHostShareButtonController.$inject = ['$scope', 'HepService'];
module.exports = GridFetchHostShareButtonController;